export const modalInformation = {
  totalStatistics: {
    title: 'Total Statistics',
    textHTML: `
      <p>
        The overall statistics gauge pointer shows how good your candidate performed in comparison to other candidates that
        have taken the test on the platform.
      </p>
      <p>
        This gives you an indication whether this was a good result in relation to other companies' candidates on this task.
      </p>`,
  },
  candidateScore: {
    title: 'Candidate Score',
    textHTML: `
      <p>
        The candidate's code is evaluated depending on a set of test cases that are run once the solution is submitted. Some
        of them are public for the candidate to review, while some are hidden.
      </p>
      <p>This will result in a final score between 0-100.</p>`,
  },
  totalDistribution: {
    title: 'Total Distribution',
    textHTML: `
      <p>
        The overall distribution graph shows you the total distribution of the scores on this specific task. This gives you an opportunity to evaluate in which score intervals the candidates usually end up in.
      </p>`,
  },
  testCategories: {
    title: 'Test Categories',
    textHTML: `
      <p>
        Every multichoice test has a certain amount of test categories that are being presented to the candidate. The categories are evaluated to be suited for the test in question, giving the test a segmented and wide span of questions in order to give an as fair evaluation as possible.
      </p>`,
  },
};
